import { render } from "./DockerFirstRunUbuntu.vue?vue&type=template&id=d37c80e2"
import script from "./DockerFirstRunUbuntu.vue?vue&type=script&lang=js"
export * from "./DockerFirstRunUbuntu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__